import { __assign, __rest } from "tslib";
import React, { useRef, useState } from "react";
// TODO hasError prop for red borders
export var Textarea = React.forwardRef(function (_a, ref) {
    var className = _a.className, onChange = _a.onChange, _b = _a.maxRows, maxRows = _b === void 0 ? 15 : _b, _c = _a.minRows, minRows = _c === void 0 ? 5 : _c, textareaProps = __rest(_a, ["className", "onChange", "maxRows", "minRows"]);
    var internalRef = useRef(null);
    var textareaRef = ref || internalRef;
    var _d = useState(minRows), rows = _d[0], setRows = _d[1];
    var handleChange = function (e) {
        var textareaLineHeight = 30;
        var previousRows = e.target.rows;
        e.target.rows = minRows; // reset number of rows in textarea
        var currentRows = ~~(e.target.scrollHeight / textareaLineHeight);
        if (currentRows === previousRows) {
            e.target.rows = currentRows;
        }
        if (currentRows >= maxRows) {
            e.target.rows = maxRows;
            e.target.scrollTop = e.target.scrollHeight;
        }
        setRows(currentRows < maxRows ? currentRows : maxRows);
        if (onChange) {
            onChange(e);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("textarea", __assign({ className: "w-full border-gray-300 border rounded-sm p-1 text-xl " + className, ref: textareaRef, rows: rows, "data-testid": "input", onChange: handleChange }, textareaProps))));
});
//# sourceMappingURL=Textarea.js.map